import { useState } from "react";

const LogoChip = ({ name, domain, img, boost, className = "", imgClass = "h-7 max-w-[110px]", fallbackClass = "text-sm font-semibold text-navy-deep" }) => {
  const [failed, setFailed] = useState(false);
  const src = img || (domain ? `https://icons.duckduckgo.com/ip3/${domain}.ico` : null);
  return (
    <span data-testid={`logo-${name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} className={`inline-flex items-center justify-center rounded-xl border border-white/12 bg-white px-5 py-3 ${className}`}>
      {src && !failed ? (
        <img
          src={src}
          alt={`${name} logo`}
          loading="lazy"
          draggable={false}
          onLoad={(e) => {
            if (!img && e.target.naturalWidth === 48 && e.target.naturalHeight === 48) setFailed(true);
          }}
          onError={() => setFailed(true)}
          style={boost ? { transform: `scale(${boost})` } : undefined}
          className={`object-contain transition-all duration-300 ${imgClass}`}
        />
      ) : (
        <span className={fallbackClass}>{name}</span>
      )}
    </span>
  );
};

export default LogoChip;
